// extracted by mini-css-extract-plugin
export var container = "CoreValues-module--container--b9551";
export var fadeInAnimation = "CoreValues-module--fadeInAnimation--bfd1d";
export var image = "CoreValues-module--image--f6779";
export var layout = "CoreValues-module--layout--dc822";
export var picture = "CoreValues-module--picture--9ad12";
export var statItem = "CoreValues-module--statItem--c9836";
export var statLabel = "CoreValues-module--statLabel--27fd4";
export var statValue = "CoreValues-module--statValue--360ff";
export var statsRow = "CoreValues-module--statsRow--9de9c";
export var subtitle = "CoreValues-module--subtitle--562f0";
export var title = "CoreValues-module--title--2383a";